import React, {useEffect} from 'react';
import PropTypes from 'prop-types';

import {CircularProgress, Backdrop} from '@ui';
import {getLink} from '@appComponents/Link';
import {renderModalError} from '@utils/forms';
import {showModal} from '@utils/modal';

const ARGOS_JOB_ENTITY_NAME = 'Argos job';

export const argosJobBelongsToEvent = (argosJobId, jobs) =>
    jobs?.some(job => String(job.id) === String(argosJobId)) ?? false;

export const ArgosJobRouteGuard = ({eventId, argosJobId, jobs, children}) => {
    const belongsToEvent = argosJobBelongsToEvent(argosJobId, jobs);

    useEffect(() => {
        if (belongsToEvent) {
            return;
        }

        showModal({
            isVisible: true,
            content: renderModalError(
                ARGOS_JOB_ENTITY_NAME,
                getLink('events.argosJobs.index', {id: eventId})
            ),
        });
    }, [belongsToEvent, eventId]);

    if (!belongsToEvent) {
        return (
            <Backdrop open inverted>
                <CircularProgress />
            </Backdrop>
        );
    }

    return children;
};

ArgosJobRouteGuard.propTypes = {
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    argosJobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    jobs: PropTypes.array,
    children: PropTypes.node,
};
